import type { PassRouteDescriptor } from '../routeDescriptor'
import GeofenceWaitlist from './GeofenceWaitlist'
export const geofenceWaitlistRoutes: PassRouteDescriptor[] = [{ path: 'waitlist', element: <GeofenceWaitlist/> }]
